import React from 'react';
import type {ManagerArtist} from '@deezer/next/features/ClaimAccess/types';
import Row from '@components/Table/rows/Row';
import {useTableContext} from '@components/Table';
import {ArtistTableColumn} from './types';
import IconButtonCell from '@components/Table/cells/IconButtonCell';
import {PenIcon, TrashIcon} from '@tempo/icons';
import ArtistNameCell from './ArtistNameCell';
import UPCCell from '@components/Table/cells/UPCCell';

type ArtistTableRowProps = {
	artist: ManagerArtist;
	rowIndex: number;
	onArtistEdit: (artist: ManagerArtist) => void;
	onArtistRemove: (artist: ManagerArtist) => void;
};

const ArtistTableRow = ({
	artist,
	rowIndex,
	onArtistRemove,
	onArtistEdit,
}: ArtistTableRowProps) => {
	const {columns} = useTableContext<ArtistTableColumn>();

	const handleRemoveClick = () => {
		onArtistRemove(artist);
	};

	const handleEditClick = () => {
		onArtistEdit(artist);
	};

	return (
		<Row key={rowIndex} index={rowIndex}>
			{columns.map((column, index) => {
				const key = column.id + index;
				switch (column.id) {
					case ArtistTableColumn.NAME:
						return (
							<ArtistNameCell
								key={key}
								artist={artist}
								display={column.display}
							/>
						);
					case ArtistTableColumn.UPC:
						return (
							<UPCCell key={key} upc={artist.upc} display={column.display} />
						);
					case ArtistTableColumn.EDIT:
						return (
							<IconButtonCell
								key={key}
								aria-label={'edit'}
								icon={<PenIcon />}
								display={column.display}
								onClick={handleEditClick}
							/>
						);
					case ArtistTableColumn.DELETE:
						return (
							<IconButtonCell
								key={key}
								aria-label={'delete'}
								icon={<TrashIcon />}
								display={column.display}
								onClick={handleRemoveClick}
							/>
						);
				}
			})}
		</Row>
	);
};

export default ArtistTableRow;
